"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrashIcon = void 0;
var react_1 = __importDefault(require("react"));
var TrashIcon = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { className: className, width: "33", height: "32", viewBox: "0 0 33 32", fill: "#fff", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M8.27667 25.3335C8.27667 26.8001 9.4981 28.0001 10.991 28.0001H21.8481C23.341 28.0001 24.5624 26.8001 24.5624 25.3335V9.33346H8.27667V25.3335ZM25.9195 5.33346H21.1695L19.8124 4.00012H13.0267L11.6695 5.33346H6.91953V8.00012H25.9195V5.33346Z" })));
};
exports.TrashIcon = TrashIcon;
